/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_Layout_LabelInputs */



/**
* | output |
* | --- |
* | "Field Layout" |
*
* @param {Transcript_Export_Field_Layout_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_layout_label = /** @type {((inputs?: Transcript_Export_Field_Layout_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_Layout_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "it") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "es") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Field Layout")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Field Layout")
	return /** @type {LocalizedString} */ ("Field Layout")
});